import { render } from "./view-manager-module.vue?vue&type=template&id=b2450654&scoped=true"
import script from "./view-manager-module.vue?vue&type=script&lang=js"
export * from "./view-manager-module.vue?vue&type=script&lang=js"

import "./view-manager-module.vue?vue&type=style&index=0&id=b2450654&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2450654"]])

export default __exports__